export const projectFile = 'vr'
export const sourcePath = window.hasKrpano
  ? `./vr/frontEnd/plugin/${projectFile}/`
  : './'
